import React from 'react';

import Layout from '@components/layout';
import SEO from '@components/seo';
import Banner from '@components/banner';
import DiscoverProducts from '@components/discoverProducts';
import { CategoryCompliance } from '@constants/app';

import '@styles/styles.scss';

const CompliancePage = ({ data }) => {
  const ctf = data.contentfulDiscoverPages;
  const {
    forComplianceBannerTitle,
    forComplianceBannerSubtitle,
    forComplianceBannerImageTitle,
    forComplianceTitle,
    forComplianceDescription
  } = ctf;
  const assets = data.allContentfulAsset.edges.map(edge => edge.node);

  const tradeUpDescription = ctf.tradeUpDescription.tradeUpDescription;
  const workUpDescription = ctf.workUpDescription.workUpDescription;
  const serviceUpDescription = ctf.serviceUpDescription.serviceUpDescription;
  const projectUpDescription = ctf.projectUpDescription.projectUpDescription;
  const checkUpDescription = ctf.checkUpDescription.checkUpDescription;
  const upFamilyDescription = ctf.upFamilyDescription.upFamilyDescription;

  return (
    <Layout>
      <SEO title="DiscoverCompliance"/>
      <Banner
        assets={assets}
        imageTitle={forComplianceBannerImageTitle}
      >
        <div className="d-flex flex-column mt-3 mb-5 mb-md-0">
          <h1>{forComplianceBannerTitle}</h1>
          <p className="text-muted">{forComplianceBannerSubtitle.forComplianceBannerSubtitle}</p>
        </div>
      </Banner>
      <DiscoverProducts
        productCategory={CategoryCompliance}
        title={forComplianceTitle}
        description={forComplianceDescription.forComplianceDescription}
        tradeUpDescription={tradeUpDescription}
        workUpDescription={workUpDescription}
        serviceUpDescription={serviceUpDescription}
        projectUpDescription={projectUpDescription}
        checkUpDescription={checkUpDescription}
        upFamilyDescription={upFamilyDescription}
      />
    </Layout>
  );
};

export default CompliancePage;

export const pageQuery = graphql`
  query DiscoverComplianceQuery {
    contentfulDiscoverPages {
      forComplianceBannerTitle
      forComplianceBannerSubtitle {
        forComplianceBannerSubtitle
      }
      forComplianceBannerImageTitle
      forComplianceTitle
      forComplianceDescription {
        forComplianceDescription
      }
      tradeUpDescription {
        tradeUpDescription
      }
      workUpDescription {
        workUpDescription
      }
      serviceUpDescription {
        serviceUpDescription
      }
      projectUpDescription {
        projectUpDescription
      }
      checkUpDescription {
        checkUpDescription
      }
      upFamilyDescription {
        upFamilyDescription
      }
    }
    allContentfulAsset {
      edges {
        node {
          title
          file {
            contentType
            url
            fileName
          }
          fixed {
            height
            width
            src
            srcSet
          }
          fluid(maxWidth: 980) {
            ...GatsbyContentfulFluid
          } 
        }
      }
    }
  }
`;
